var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5118 1.48816L12.9361 1.06389V1.06389L12.5118 1.48816ZM3.33333 13.0237V13.6237C3.49246 13.6237 3.64508 13.5604 3.7576 13.4479L3.33333 13.0237ZM1 13.0237H0.4C0.4 13.355 0.668629 13.6237 1 13.6237L1 13.0237ZM1 10.6429L0.575736 10.2187C0.463214 10.3312 0.4 10.4838 0.4 10.6429H1ZM10.579 1.91242C10.9956 1.49586 11.671 1.49586 12.0875 1.91242L12.9361 1.06389C12.0509 0.178703 10.6157 0.178703 9.73052 1.06389L10.579 1.91242ZM12.0875 1.91242C12.5041 2.32898 12.5041 3.00435 12.0875 3.42091L12.9361 4.26944C13.8213 3.38425 13.8213 1.94908 12.9361 1.06389L12.0875 1.91242ZM12.0875 3.42091L2.90907 12.5994L3.7576 13.4479L12.9361 4.26944L12.0875 3.42091ZM3.33333 12.4237H1V13.6237H3.33333V12.4237ZM9.73052 1.06389L0.575736 10.2187L1.42426 11.0672L10.579 1.91242L9.73052 1.06389ZM0.4 10.6429V13.0237H1.6V10.6429H0.4ZM8.73052 2.91242L11.0875 5.26944L11.9361 4.42091L9.57905 2.06389L8.73052 2.91242Z",
    fill: "#EAA827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconNew);
export default __webpack_public_path__ + "static/media/edit-icon-new.62e188058b03d800386faf4b9e45636f.svg";
export { ForwardRef as ReactComponent };